import React, {Component, PropTypes} from 'react';
import SelectedItem from "./SelectedItem";

class IngredientsSearchSelectedItems extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { selectedIngredients, onIngredientRemove, onIngredientQtyUpdate, onIngredientUnitUpdate, unitTypes } = this.props;

    return (
      <div className={ 'selected-ingredients' }>
        <div className={ 'selected-items-header' }>
          <h4>Selected Item List</h4>
          {selectedIngredients.length === 0 ? '' : <span className={ 'optional-label-text' }>Qty And Units Are Optional</span>}
        </div>
        <div className='editable-table'>
          { 
            selectedIngredients.length === 0 ? 
              <div className={'no-data-available'}>No Selected Items. Let's Start Adding.</div> :
              
              <table>
                <thead>
                  <tr>
                    <th scope='col'>Item</th>
                    <th scope='col' className={ 'optional-column' }>QTY</th>
                    <th scope='col' className={ 'optional-column' }>Unit</th>
                    <th scope='col' className={ 'text-to-right' }>Cost</th>
                    <th scope='col' />
                  </tr>
                </thead>
                <tbody>

                { selectedIngredients.map((ingredient) => {
                    return (
                    <SelectedItem
                        key = { ingredient.uniqKey }
                        ingredient={ ingredient }
                        onIngredientRemove={ onIngredientRemove }
                        onIngredientQtyUpdate={ onIngredientQtyUpdate }
                        onIngredientUnitUpdate={ onIngredientUnitUpdate }
                        unitTypes={ unitTypes }
                    />
                    );
                  })
                }
                </tbody>
              </table>
          }
        </div>
      </div>

    );
  }
}

IngredientsSearchSelectedItems.propTypes = {
  selectedIngredients: PropTypes.array,
  onIngredientRemove: PropTypes.func,
  onIngredientQtyUpdate: PropTypes.func,
  onIngredientUnitUpdate: PropTypes.func,
  unitTypes: PropTypes.object
};

export default IngredientsSearchSelectedItems;
